export default __webpack_public_path__ + "static/media/sprite.8699d159.svg";